import fn from '../../Functii'

export function acBilet(val) {
    // console.log('acBilet - ', val);

    switch (val[0]) {
        case 'biletNou': {
            return {
                type: 'BILET_NOU',
                payload: val[1]
            }
        }
        case 'biletNumere': {
            var valBiletNumere = {
                numere: fn.changeArrayValues([val[1].number, val[1].biletNumbers]),
                position: val[1].position,
                odds: val[1].odds
            }
            return {
                type: 'BILET_NUMERE',
                payload: valBiletNumere,
            }
        }
        case 'biletFavNumere': {
            var arr = []
            for (let i = 0; i < val[1].favNumber.split(', ').length; i++) {
                arr.push(parseInt(val[1].favNumber.split(', ')[i], 10))
            }
            var valBiletNumereFav = {
                numere: arr,
                position: val[1].position,
                odds: val[1].odds
            }
            return {
                type: 'BILET_NUMERE',
                payload: valBiletNumereFav,
            }
        }
        case 'biletStatisticsNumere': {

            var valBiletNumereStatistici = {
                numere: val[1].statisticsNumber,
                position: val[1].position,
                odds: val[1].odds
            }

            return {
                type: 'BILET_NUMERE',
                payload: valBiletNumereStatistici,
            }
        }
        case 'biletRandomNr': {

            var valBiletNumereRandom = {
                numere: val[1].randomNumbers,
                position: val[1].position,
                odds: val[1].odds
            }

            return {
                type: 'BILET_NUMERE',
                payload: valBiletNumereRandom,
            }
        }
        case 'biletNouSamepoz': {
            return {
                type: 'BILET_NOU_SAMEPOZ',
                payload: val[1]
            }
        }
        case 'biletMiza': {
            return {
                type: 'BILET_MIZA',
                payload: val[1]
            }
        }
        case 'biletSaveFav': {
            return {
                type: 'BILET_SAVE_FAV',
                payload: val[1]
            }
        }
        case 'biletChecked': {
            var checked = '';
            if (val[1].type === 'multy') {
                checked = fn.changeArrayValues([val[1].value, val[1].checked]);
                if (checked.length === 0) {
                    if (val[1].numereArr.length < val[1].odds.length) {
                        checked = [val[1].numereArr.length]
                    } else {
                        checked = [val[1].odds.length]
                    }
                }
            } else if (val[1].type === 'unique') {
                checked = [val[1].value]
            }
            var valBiletChecked = {
                checked: checked,
                position: val[1].position,
            }
            return {
                type: 'BILET_CHECKED',
                payload: valBiletChecked
            }
        }
        case 'changeRound': {

            var info = {
                position: val[1].position,
                gameType: val[1].gameType,
                idRunda: val[1].id,
                roundUnique: val[1].round_unique,
                numeLot: val[1].selectedLot,
                timeStart: val[1].timeStart,
                futureArr: val[1].futureArr
            }
            return {
                type: 'CHANGE_ROUND',
                payload: info
            }
        }
        case 'sendTicket': {
            if (val[2].status === 'succes') { var valid = true; }
            if ((val[2].status === 'error') || (val[2].status === 'popup')) { valid = false; }
            var sendTicket = {
                position: val[1].position,
                status: val[2].status,
                mesaj: val[2].value,
                valid: valid,
                end_time: val[1].timeStart
            }
            return {
                type: 'SEND_TICKET',
                payload: sendTicket
            }
        }
        case 'resetMessage': {
            return {
                type: 'RESET_MESSAGE',
            }
        }
        case 'validTicket': {
            return {
                type: 'VALID_TICKET',
                payload: val[1]
            }
        }
        case 'biletDelete': {
            return {
                type: 'BILET_DELETE',
                payload: val[1]
            }
        }
        case 'future': {
            return {
                type: 'BILET_FUTURE',
                payload: val[1]
            }
        }
        default: {
            return null;
        }
    }
}
